/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

/* eslint-disable max-len */
import { ServiceEndpoint } from 'client-code/sls-service-endpoints';
import { ISlsServiceGlobalEndpointsServiceRepository } from '../interfaces/ISlsServiceGlobalEnpointsServiceRepository';
import { SlsServiceGlobalEndpointsServiceRepositoryImpl } from '../impls/SlsServiceGlobalEnpointsServiceRepositoryImpl';

export class SlsServiceGlobalEndpointsService
    implements ISlsServiceGlobalEndpointsServiceRepository
{
    // TDOD: We need to move this hardcoded service names to the config.js

    public static MSO_DEFAULT_BRANDING_SERVICE = 'cloudcore-branding-service';

    public static DEVICE_BINDING_SERVICE = 'devicebindingservice';

    public static IPTV_LOGIN_SERVICE = 'iptv-login-service';

    public static DOMAIN_TOKENS = 'domain-tokens';

    private mBaseUrl: string;

    constructor(baseUrl: string) {
        this.mBaseUrl = baseUrl;
    }

    static getServiceEndpointByServiceName(serviceName: string): string {
        return SlsServiceGlobalEndpointsServiceRepositoryImpl.getServiceEndpointByServiceName(
            serviceName,
        );
    }

    async fetchSlsGlobalEndpoints(): Promise<ServiceEndpoint[]> {
        return new SlsServiceGlobalEndpointsServiceRepositoryImpl(
            this.mBaseUrl,
        ).fetchSlsGlobalEndpoints();
    }
}
